import { ChevronLeft } from 'lucide-react'
import { useTranslation } from 'react-i18next'

interface BackButtonProps {
  onClick: () => void
  label?: string
  className?: string
}

export default function BackButton({ onClick, label, className = 'mb-4' }: BackButtonProps) {
  const { t } = useTranslation('common')
  return (
    <button onClick={onClick} className={`flex items-center gap-1 text-gold text-sm font-medium ${className}`}>
      <ChevronLeft size={16} />
      {label ?? t('actions.backToSettings')}
    </button>
  )
}
